/* global axios */
import ApiClient from './ApiClient';

class ContactBilling extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  linksUrl(contactId, linkId = '') {
    return `${this.url}/${contactId}/billing_links${linkId ? `/${linkId}` : ''}`;
  }

  getLinks(contactId) {
    return axios.get(this.linksUrl(contactId));
  }

  saveLink(contactId, linkId, data) {
    return linkId
      ? axios.patch(this.linksUrl(contactId, linkId), data)
      : axios.post(this.linksUrl(contactId), data);
  }

  removeLink(contactId, linkId) {
    return axios.delete(this.linksUrl(contactId, linkId));
  }

  charges(contactId, linkId, page) {
    return axios.get(`${this.linksUrl(contactId, linkId)}/charges`, {
      params: { page },
    });
  }

  preview(contactId, linkId, data) {
    return axios.post(`${this.linksUrl(contactId, linkId)}/preview`, data);
  }

  sendCharge(contactId, linkId, data) {
    return axios.post(`${this.linksUrl(contactId, linkId)}/send_charge`, data);
  }
}

export default new ContactBilling();
